import type { Directive } from 'vue'

export const vOutsideClick: Directive = {
  mounted(el, binding) {
    const handler = (event: PointerEvent) => {
      if (!el.contains(event.target as Node)) {
        binding.value(event)
      }
    }

    el.__outsideClickHandler__ = handler

    document.addEventListener(
      'pointerdown',
      handler
    )
  },

  unmounted(el) {
    document.removeEventListener(
      'pointerdown',
      el.__outsideClickHandler__
    )
  }
}
